function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87109 17.8994V6.51172H0.329102V17.8994H3.87109ZM2.08105 4.98828C3.22363 4.98828 4.1377 4.03613 4.1377 2.89355C4.1377 1.78906 3.22363 0.875 2.08105 0.875C0.976562 0.875 0.0625 1.78906 0.0625 2.89355C0.0625 4.03613 0.976562 4.98828 2.08105 4.98828ZM17.0869 17.8994H17.125V11.6533C17.125 8.60645 16.4395 6.24512 12.8594 6.24512C11.1455 6.24512 10.0029 7.19727 9.50781 8.07324H9.46973V6.51172H6.08008V17.8994H9.62207V12.2627C9.62207 10.7773 9.88867 9.36817 11.7168 9.36817C13.5449 9.36817 13.583 11.0439 13.583 12.377V17.8994H17.0869Z",
  fill: "white"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.01d78e42.svg";
export { ForwardRef as ReactComponent };